<!--The content below is only a placeholder and can be replaced.-->


<router-outlet></router-outlet>
<div class="sendFormTest dev-only">
        <a href="javascript:void(0)" class="float-left" (click)="sendFormTest()">sendFormTest</a>
</div>
<div #dev class="dev-only d-inline-block m-quick-links">
    <a href="javascript:void(0)" (click)="dev.show=!dev.show">{{'{'}}#{{'}'}}</a>
    <nav *ngIf="1||dev.show" class="dev d-inline-block">
        <div>dev quick links</div>
        <ul>
            <li><a routerLink="/" routerLinkActive="active">start</a></li>
            <li><a routerLink="/questionnaire/user-details/1" routerLinkActive="active">user-details</a>&nbsp;,<a routerLink="/questionnaire/user-details/all">all</a></li>
            <li><a routerLink="/questionnaire/loan-details/1" routerLinkActive="active">loan-details</a></li>
            <li><a routerLink="/questionnaire/property-details/1" routerLinkActive="active">property-details</a></li>
            <li><a routerLink="/questionnaire/borrowers-details/1" routerLinkActive="active">borrowers-details</a></li>
            <li><a routerLink="/questionnaire/liabilities/1" routerLinkActive="active">liabilities</a></li>
            <li><a routerLink="/questionnaire/financing-sources/1" routerLinkActive="active">financing-sources</a></li>
            <li><a routerLink="/summarize" routerLinkActive="active">summarize</a></li>
            <li><a routerLink="/end" routerLinkActive="active">end</a></li>
        </ul>
				<!-- <div>{{enviroment.appVersion}}</div> -->
        </nav>
        
</div>
<app-footer></app-footer>


// WEBPACK FOOTER //
// ./src/app/app.component.html